import React from "react";

export const Image3 = ({ title3, largeImage3, smallImage3 }) => {
  return (
    <div className="portfolio-item">
      <div className="hover-bg">
        {" "}
        <a href={largeImage3} title3={title3} data-lightbox-gallery="gallery3">
          <div className="hover-text">
            <h4>{title3}</h4>
          </div>
          <img src={smallImage3} className="img-responsive" alt={title3} />{" "}
        </a>{" "}
        
      </div>
    </div>
    
  );
};
